import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 获取路由
 *
 * @returns 路由定义
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'task/questionnaire/:taskMsg',
    getTitle: () => '问卷',
    name: 'QuestionnaireTask',
    component: lazy(() =>
      import('./pages/Questionnaire').then((m) => ({
        default: m.Questionnaire,
      }))
    ),
  },
]
